/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Deleted/Active/Post
 * @desc Filter Deleted Active Post
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { PostFilterDeleted } from 'labstep-web/services/postFilter/filters/deleted';
import type React from 'react';

export const FilterPostNewIndexDeletedActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  if (!PostFilterDeleted.isNodeActive(node)) {
    return null;
  }
  return (
    <RemoveLabel
      icon="trash"
      name="Deleted"
      onRemoveClick={onRemoveClick}
    />
  );
};
